import React from "react";

const CASettingsPage = () => {
    return (
        <>
            <h1>This CASettingsPage</h1>
        </>
    );
}

export default CASettingsPage;
